// Mega menu scroll margin — uniform offset when scrolled (sticky header layout shift)
(function() {
  'use strict';

  var menuSelector = '.t4s-header__wrapper:not(.t4s-layout_vertical) .menu-width__full .t4s-sub-menu';
  var ticking = false;
  var lastScrollTop = 0;

  function adjustMenuMargin() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop === lastScrollTop) {
      ticking = false;
      return;
    }

    lastScrollTop = scrollTop;
    var marginValue = scrollTop > 0 ? '-32px' : '0';

    document.querySelectorAll(menuSelector).forEach(function(element) {
      element.style.marginLeft = marginValue;
    });

    ticking = false;
  }

  function onScrollOrResize() {
    if (!ticking) {
      requestAnimationFrame(adjustMenuMargin);
      ticking = true;
    }
  }

  function init() {
    adjustMenuMargin();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
